import { observer } from 'mobx-react';
import * as React from 'react';
import TextareaAutosize from 'react-autosize-textarea/lib';
import { PhotoViewerConstants, PhotoViewerConstants as ui } from '../../Config/UIConstants';
import { FullContainer } from '../../SharedComponents/FullContainer';
import { CommentEditState } from '../../Stores/CommentEditState';
import { colors } from '../../styles/colors';
import { isNotNullOrWhitespace } from '../../util/string.utils';
import { NewCommentAudioRecorder } from './Audio/NewCommentAudioRecorder';
import { CommentType } from './PhotoViewer';

interface IProps {
    activeCommentType: CommentType;
    onAddComment(): void;
    setReference?(ref: any): void;
    commentEditState: CommentEditState;
}

export const CommentInput = observer(function({
        activeCommentType, onAddComment, commentEditState, setReference
    }: IProps) {
    if (activeCommentType === CommentType.WRITE) {
        let commentText: string | undefined;
        if (commentEditState) {
            commentText = commentEditState.commentText;
        }

        return (
            <FullContainer style={styles.container}>
                <TextareaAutosize
                    onChange={(event: any) => {
                        commentEditState.setCommentText(event.target.value);
                    }}
                    maxRows={12}
                    style={styles.input}
                    value={commentText}
                    placeholder={ui.ADD_TO_STORY}
                    innerRef={(reference: any) => (setReference ? setReference(reference) : {})}
                />
                <div style={styles.submitContainer}>
                    {isNotNullOrWhitespace(commentText) && (
                        <a style={styles.submitButton} onClick={onAddComment}>
                            {PhotoViewerConstants.ADD}
                        </a>
                    )}
                </div>
            </FullContainer>
        );
    } else {
        return (
            <NewCommentAudioRecorder recorderUseMode={commentEditState.recorderUseMode} onRecordingComplete={onAddComment} commentEditState={commentEditState} />
        );
    }
});

const styles = {
    container: { padding: 25 },
    input: { width: '100%', padding: 20, outline: 'none', border: 'none', margin: 0, fontSize: 14 },
    submitContainer: { height: 40, width: '100%', backgroundColor: 'white', marginTop: -10, position: 'relative' } as React.CSSProperties,
    submitButton: {
        color: colors.ACTION_GREEN,
        fontSize: 16,
        position: 'absolute',
        right: 15,
        cursor: 'pointer',
        top: 10,
    } as React.CSSProperties,
};



// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/CommentInput.tsx